import React from 'react';
import PropTypes from 'prop-types';

import featureToggles from 'shared-assets/lib/sdk/featureToggles';

class FeatureToggle extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      feature: null,
      negated: false,
      show: false,
    };
  }

  static getDerivedStateFromProps(props) {
    return {
      feature: !!props.if.startsWith('!') ? props.if.substring(1) : props.if,
      negated: !!props.if.startsWith('!'),
    };
  }

  componentDidMount() {
    this.checkFeatureToggle();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.if !== this.props.if) {
      this.checkFeatureToggle();
    }
  }

  checkFeatureToggle = () => {
    if (!!this.state.feature) {
      featureToggles.isEnabled(this.state.feature).then(isEnabled => {
        if (this.state.negated && !isEnabled) {
          this.setState({
            show: true,
          });
        } else if (!this.state.negated && isEnabled) {
          this.setState({
            show: true,
          });
        }
      });
    }
  };

  render() {
    return (
      <If condition={this.state.show && this.props.children}>
        {this.props.children}
      </If>
    );
  }
}
FeatureToggle.defaultProps = {
  children: null,
};
FeatureToggle.propTypes = {
  children: PropTypes.node,
  if: PropTypes.string.isRequired,
};

export default FeatureToggle;
